// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IBalanceHistoryCloseDto } from './IBalanceHistoryCloseDto';
import {
    IBalanceHistoryCloseDtoFromJSON,
    IBalanceHistoryCloseDtoFromJSONTyped,
    IBalanceHistoryCloseDtoToJSON,
    IBalanceHistoryCloseDtoToJSONTyped,
} from './IBalanceHistoryCloseDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageBalanceHistoryCloseDto
 */
export interface IPageBalanceHistoryCloseDto {
    /**
     * 
     * @type {number}
     * @memberof IPageBalanceHistoryCloseDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageBalanceHistoryCloseDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageBalanceHistoryCloseDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IBalanceHistoryCloseDto>}
     * @memberof IPageBalanceHistoryCloseDto
     */
    content?: Array<IBalanceHistoryCloseDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageBalanceHistoryCloseDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageBalanceHistoryCloseDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageBalanceHistoryCloseDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageBalanceHistoryCloseDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageBalanceHistoryCloseDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageBalanceHistoryCloseDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageBalanceHistoryCloseDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageBalanceHistoryCloseDto interface.
 */
export function instanceOfIPageBalanceHistoryCloseDto(value: object): value is IPageBalanceHistoryCloseDto {
    return true;
}

export function IPageBalanceHistoryCloseDtoFromJSON(json: any): IPageBalanceHistoryCloseDto {
    return IPageBalanceHistoryCloseDtoFromJSONTyped(json, false);
}

export function IPageBalanceHistoryCloseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageBalanceHistoryCloseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IBalanceHistoryCloseDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageBalanceHistoryCloseDtoToJSON(json: any): IPageBalanceHistoryCloseDto {
    return IPageBalanceHistoryCloseDtoToJSONTyped(json, false);
}

export function IPageBalanceHistoryCloseDtoToJSONTyped(value?: IPageBalanceHistoryCloseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IBalanceHistoryCloseDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

